import * as React from 'react';

const InterStage = props => {
  const { className } = props;
  const interStageImagePath = 'assets/inter-stage-1.png';
  return <img className={className} src={interStageImagePath} />;
};

export default InterStage;
